import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { PromoStrip } from "./PromoStrip";

const HIDE_ON = ["/cart", "/checkout"];

export const GlobalPromoStrip = () => {
  const { pathname } = useLocation();
  const [lines, setLines] = useState([]);
  useEffect(() => {
    api.get("/settings").then((r) => setLines(r.data.promo_lines || [])).catch(() => {});
  }, []);
  if (HIDE_ON.some((p) => pathname.startsWith(p))) return null;
  return <PromoStrip lines={lines} />;
};
